import TextField from "@/common/elements/InputElements/TextField";
import React, { useEffect, useState } from "react";
import Button from "@/common/elements/Button";
import Select from "@/common/elements/InputElements/Select";
import {
  MedicalModalHeaderContainer,
  QuestionnaireModalBodyContainer,
  SectionHeading,
} from "./styles";
import { Form } from "antd";
import Modal from "@/common/elements/Modal";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import CommonDatePicker from "@/common/elements/DatePicker";
import dayjs, { isDayjs } from "dayjs";
import _ from "lodash";
import { useSelector } from "react-redux";

const ModalHeader = ({ questionnaire, onHide, totalPoints }) => {
  return (
    <>
      {/* <Button color="primary" type="primary" onClick={onHide}>
        Exit
      </Button> */}
      <div
        className="questionnaire-scores-container"
        style={{ marginLeft: "0px", marginRight: "0px" }}
      >
        <div className="main-score-container score-container">
          <div className="score-name">
            {questionnaire?.questionnaireName || ""}
          </div>
          <div className="score">
            <span className="points-caption">Total Points: </span>{" "}
            {totalPoints || 0}
          </div>
        </div>
      </div>
      {/* <div className="section-score-container score-container">
        <div className="score-name">{qg?.subheading}</div>
        <div className="score">
          <span className="points-caption">Total Points: </span>0
        </div>
      </div> */}
      {/* <div className="time">
        <img alt="Clock Icon" src={clock} /> N / A
      </div> */}
    </>
  );
};

const MedicalQuestionnaireModal = ({
  show,
  onHide,
  questionnaire,
  getAnswer,
  singleQuestionnaire,
  isEdit = false,
}) => {
  const { bookings } = useSelector((state) => state?.bookings);
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState(null);
  const [questionnaireLocal, setQuestionnaireLocal] = useState(null);
  const [previousQuestion, setPreviousQuestion] = useState({
    questionID: 0,
    point: 0,
    answer: "",
  });
  const values = Form.useWatch("questionAnswers", form);
console.log({singleQuestionnaire})
  useEffect(() => {
    const ques = [];
    let questionGroupPoints = [];
    let totalPoints = 0;
    const copyQuestionnaire = _.cloneDeep(questionnaire);
    let group = copyQuestionnaire?.questionGroups?.map((g) => {
      return {
        ...g,
        questions: _.sortBy(g?.questions, "sequence"),
      };
    });
    group = _.sortBy(group, "sequence");

    if (copyQuestionnaire?.questionnaireID === 4) {
      if (bookings?.bio?.[0]?.sex === "M")
        group = group?.filter((g) => g?.questionGroupID !== 12);
    }

    group = updateQuestionSequence(group);

    if (isEdit) {
      singleQuestionnaire?.questionnaireInstances?.forEach((item) => {
        questionGroupPoints = item?.questionGroupPoints;
        totalPoints = item?.totalPoints;
        item?.questionAnswers?.forEach((answer) => {
          ques.push({
            questionId: answer.questionId,
            answer: isNonEmptyVariable(answer?.answer)
              ? !isNaN(answer?.answer) && !isDayjs(answer?.answer)
                ? parseInt(answer?.answer)
                : answer?.answer
              : "",
          });
        });
      });

      group?.forEach((g) => {
        g?.questions?.forEach((q) => {
          const qa = ques?.findIndex((q1) => q1?.questionId === q?.questionID);
          if (isNonEmptyVariable(qa) && qa !== -1) {
            ques[qa].points =
              q?.questionSideEffects?.find(
                (p) => p?.answerToTriggerOnID === ques[qa]?.answer
              )?.numberOfPoints || 0;
          }
        });
      });

      group = group?.map((item) => {
        return {
          ...item,
          questions: item?.questions?.map((q) => {
            const qa = ques?.findIndex(
              (q1) => q1?.questionId === q?.questionID
            );
            q.point =
              q?.questionSideEffects?.find(
                (p) => p?.answerToTriggerOnID === ques[qa]?.answer
              )?.numberOfPoints || 0;

            return q;
          }),
        };
      });
    } else {
      group?.forEach((qg) => {
        qg?.questions?.forEach((question) => {
          ques.push({
            questionId: question.questionID,
            answer: "",
            point: 0,
          });
        });
      });

      group = group?.map((item) => {
        return {
          ...item,
          questions: item?.questions?.map((q) => {
            q.point = 0;
            return q;
          }),
        };
      });
      questionGroupPoints = copyQuestionnaire?.questionGroups?.map((qg) => ({
        questionGroupId: qg?.questionGroupID,
        totalPoints: qg?.totalPoints || 0,
      }));
      totalPoints = copyQuestionnaire?.totalPoints;
    }

    const questionnaireNew = {
      ...copyQuestionnaire,
      questionGroups: group,
    };

    setQuestionnaireLocal(() => questionnaireNew);

    setInitialValues({
      questionAnswers: ques,
      questionGroupPoints: questionGroupPoints,
      totalPoints: totalPoints || 0,
    });
  }, [questionnaire, singleQuestionnaire]);

  useEffect(() => {
    if (isNonEmptyVariable(initialValues)) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  // For classification - To setup the minimum/Maximum value based on first 9 questions
  useEffect(() => {
    if (isNonEmptyVariable(questionnaireLocal)) {
      const questionGroup = questionnaireLocal?.questionGroups?.slice(0, 3);
      if (
        isNonEmptyVariable(questionGroup) &&
        questionnaireLocal?.questionnaireName === "Classification"
      ) {
        let questions = [];
        questionGroup?.forEach((qg) => {
          qg?.questions?.forEach((q) => {
            questions.push(q);
          });
        });

        questions = questions?.slice(0, 9);
        const totalPoint = questions?.reduce((acc, q) => {
          if (isNonEmptyVariable(q?.point)) return (acc += q?.point);
          else return acc;
        }, 0);

        const questions1to3 = questions?.slice(0, 3);
        const totalPoint1to3 = questions1to3?.reduce((acc, q) => {
          if (isNonEmptyVariable(q?.point)) return (acc += q?.point);
          else return acc;
        }, 0);
        const position = getQuestionPositinFromQuestionID(null, null, 181);

        if (totalPoint1to3 >= 7) {
          form.setFieldValue(position, 100160003); // Min
          return;
        }

        if (totalPoint <= 5) {
          form.setFieldValue(position, 100160001); // Min
        } else if (totalPoint > 5 && totalPoint <= 10) {
          form.setFieldValue(position, 100160002); // Med
        } else if (totalPoint > 10) {
          form.setFieldValue(position, 100160003); // Max
        } else {
          // form.setFieldValue(getQuestionPositinFromQuestionID(null, null, 181), 100160003); // Max
        }
      }
    } else {
    }
  }, [questionnaireLocal]);

  function updateQuestionSequence(data) {
    let sequenceNumber = 1; // Start sequence from 1

    data?.forEach((group) => {
      group?.questions?.forEach((question) => {
        question.sequence = sequenceNumber++;
      });
    });

    return data;
  }

  const handleCancel = () => {
    onHide();
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((value) => {
        const obj = {
          ...initialValues,
          questionnaireId: questionnaire?.questionnaireID,
        };
        const returnData = _.cloneDeep(obj);
        getAnswer(returnData);
        setInitialValues(null);
        form?.resetFields();
      })
      .catch((err) => {
        let requiredField = err?.errorFields?.[0]?.name?.[1];
        if (isNonEmptyVariable(requiredField)) {
          requiredField = parseInt(requiredField) + 1;
          setTimeout(() => {
            const firstErrorField = document.querySelector(
              `#ques-${requiredField}`
            );

            firstErrorField?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstErrorField?.focus();
          }, 300);
        }
      });
  };

  const handleKeyDownChange = (e, qg, item) => {
    const value = e.target.value;

    const points =
      isNonEmptyVariable(item?.questionSideEffects) &&
      item?.questionSideEffects?.length
        ? item?.questionSideEffects?.[0]?.numberOfPoints
        : 0;
    if (value !== "") {
      setInitialValues((prev) => ({
        totalPoints: prev?.totalPoints + points,
        questionGroupPoints: prev?.questionGroupPoints?.map((qgp) => {
          if (qgp.questionGroupId === qg.questionGroupID) {
            return {
              ...qgp,
              totalPoints: qgp?.totalPoints + points,
            };
          }
          return qgp;
        }),
        questionAnswers: prev?.questionAnswers?.map((qa) => {
          if (qa.questionId === item.questionID) {
            return {
              ...qa,
              answer: value,
            };
          }
          return qa;
        }),
      }));
    } else {
      setInitialValues((prev) => ({
        totalPoints: prev?.totalPoints - points,
        questionGroupPoints: prev?.questionGroupPoints?.map((qgp) => {
          if (qgp.questionGroupId === qg.questionGroupID) {
            return {
              ...qgp,
              totalPoints: qgp?.totalPoints - points,
            };
          }
          return qgp;
        }),
        questionAnswers: prev?.questionAnswers?.map((qa) => {
          if (qa.questionId === item.questionID) {
            return {
              ...qa,
              answer: value,
            };
          }
          return qa;
        }),
      }));
    }
  };

  const handleOnChange = (value, qg, item) => {
    let points = getPoints(value, item);

    const np = item?.questionSideEffects?.find(
      (p) => p?.answerToTriggerOnID === value
    );

    if (np?.questionSideEffectTypeID === 50200002) {
      points = isNonEmptyVariable(np?.numberOfPoints) ? -np?.numberOfPoints : 0;
    }

    let totalPoints = 0;
    let questionGroupPoints = [];
    let questionAnswers = [];

    let question = null;
    _.forEach(questionnaireLocal?.questionGroups, (g) => {
      _.forEach(g.questions, (q) => {
        if (q?.questionID === item?.questionID) {
          question = q;
          return false;
        }
      });

      if (isNonEmptyVariable(question)) {
        return false;
      }
    });
    let updatedPoint = points;
    if (previousQuestion?.questionID !== item?.questionID) {
      if (
        isNonEmptyVariable(question) &&
        isNonEmptyVariable(question?.answer) &&
        question?.answer !== value
      ) {
        if (
          question?.questionID === 178 ||
          question?.questionID === 179 ||
          question?.questionID === 180
        ) {
          if (value === 50210002) {
            updatedPoint = question?.point + 1;
          }
        }
        updatedPoint = points - question?.point;
      }
      totalPoints = initialValues?.totalPoints + updatedPoint;
      questionGroupPoints = getQuestionGroupPoints(qg, updatedPoint, "add");
    } else {
      if (previousQuestion?.answer !== value) {
        totalPoints =
          initialValues?.totalPoints + updatedPoint - previousQuestion?.point;
        questionGroupPoints = getQuestionGroupPoints(qg, points, "edit");
      }
    }

    questionAnswers = initialValues?.questionAnswers?.map((qa) => {
      if (qa.questionId === item.questionID) {
        return {
          ...qa,
          answer: value,
        };
      }
      return qa;
    });

    setInitialValues(() => ({
      totalPoints: totalPoints,
      questionGroupPoints: questionGroupPoints,
      questionAnswers: questionAnswers,
    }));

    setPreviousQuestion(() => ({
      questionID: item?.questionID,
      point: points,
      answer: value,
    }));

    setQuestionnaireLocalAnswer(value, qg, item, points);
  };

  const getPoints = (value, item) => {
    const result =
      typeof item?.questionSideEffects !== "undefined"
        ? item?.questionSideEffects?.find(
            (p) => p?.answerToTriggerOnID === value
          )?.numberOfPoints
        : 0;

    if (isNonEmptyVariable(result)) {
      return result;
    } else {
      return 0;
    }
  };

  const getQuestionGroupPoints = (qg, points, action = "add") => {
    return initialValues?.questionGroupPoints?.map((qgp) => {
      if (qgp.questionGroupId === qg.questionGroupID) {
        return {
          ...qgp,
          totalPoints:
            action == "add"
              ? qgp?.totalPoints + points
              : qgp?.totalPoints + points - previousQuestion?.point,
        };
      }
      return qgp;
    });
  };

  const setQuestionnaireLocalAnswer = (value, qg, item, points) => {
    const group = questionnaireLocal?.questionGroups?.map((g) => {
      return {
        ...g,
        questions: g?.questions?.map((q) => {
          if (item?.questionID == q.questionID) {
            return {
              ...q,
              answer: value,
              point: points,
            };
          } else {
            return q;
          }
        }),
      };
    });

    setQuestionnaireLocal(() => ({
      ...questionnaireLocal,
      questionGroups: group,
    }));
  };

  const getDependenciesQuestion = (values, item) => {
    if(isNonEmptyVariable(values)&&values?.length>0){
    const answer = values?.find(
      (qa) => qa?.questionId === item?.dependsOnQuestionID
    )?.answer;

    return (
      isNonEmptyVariable(answer) &&
      answer === item?.dependsOnQuestionAnswerRefListItemID
    );}
  };

  const getValidation = (question) => {
    if (isNonEmptyVariable(question?.mandatory)) {
      if (isNonEmptyVariable(question?.dependsOnQuestionID)) {
        const val = initialValues?.questionAnswers?.find(
          (qa) => qa?.questionId === question?.dependsOnQuestionID
        );
        if (
          isNonEmptyVariable(val) &&
          val?.answer === question?.dependsOnQuestionAnswerRefListItemID &&
          question?.mandatory
        ) {
          return [
            {
              required: true,
              message: "Field is required",
            },
          ];
        }
      } else {
        if (question?.mandatory) {
          return [
            {
              required: true,
              message: "Field is required",
            },
          ];
        }
      }
    }
  };

  const getQuestionPositinFromQuestionID = (
    questionaireQuestions,
    paramName = "",
    quesID = ""
  ) => {
    let retIndex = -1;
    if (isNonEmptyVariable(questionaireQuestions)) {
      retIndex = initialValues?.questionAnswers?.findIndex(
        (qa) => qa?.questionId === questionaireQuestions?.questionID
      );
    }

    if (isNonEmptyVariable(quesID)) {
      retIndex = initialValues?.questionAnswers?.findIndex(
        (qa) => qa?.questionId === quesID
      );
    }

    if (retIndex !== -1) {
      let name = [];
      if (isNonEmptyVariable(paramName)) {
        name = ["questionAnswers", retIndex, "questionId"];
      } else {
        name = ["questionAnswers", retIndex, "answer"];
      }

      return name;
    }
  };

  return (
    <Modal
      header=""
      show={show}
      designPattern="ant"
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      onHide={handleCancel}
      width={"80%"}
      bodyStyle={{ padding: "20px" }}
      className="no-header questionnaire-modal"
    >
      <MedicalModalHeaderContainer>
        <ModalHeader
          questionnaire={questionnaire}
          totalPoints={initialValues?.totalPoints}
          onHide={handleCancel}
        />
      </MedicalModalHeaderContainer>
      <Form form={form}>
        {isNonEmptyVariable(questionnaireLocal) &&
          questionnaireLocal?.questionGroups?.map((qg) => {
            return (
              <QuestionnaireModalBodyContainer key={qg.questionGroupID}>
                <SectionHeading className="d-flex justify-content-between section-heading text-dark">
                  <h3>{qg?.subheading}</h3>
                  <h6 style={{ paddingRight: "10px" }}>
                    Total group points:{" "}
                    {initialValues?.questionGroupPoints?.find(
                      (qgp) => qgp?.questionGroupId === qg?.questionGroupID
                    )?.totalPoints || 0}
                  </h6>
                </SectionHeading>
                <ul className="questions">
                  {qg?.questions?.map((item, quesIndex) => {
                    let sequence = item?.sequence;

                    return (
                      <li key={quesIndex} id={"ques-" + sequence}>
                        <FormItem
                          hidden
                          name={getQuestionPositinFromQuestionID(
                            item,
                            "questionId"
                          )}
                        >
                          <TextField />
                        </FormItem>
                        {!isNonEmptyVariable(item?.dependsOnQuestionID) && (
                          <div className="question-item">
                            <div className="question">
                              <span className="number">{sequence}.</span>{" "}
                              <span
                                className="question--text-label"
                                dangerouslySetInnerHTML={{
                                  __html: item?.questionText,
                                }}
                              ></span>
                            </div>
                            <div className="options-container">
                              {item?.interfaceTypeID === 50000001 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <Select
                                    id={`question-${quesIndex}`}
                                    placeholder=" Select any option"
                                    options={getOptionsFromRefList(
                                      "YesNo",
                                      false,
                                      true,
                                      true
                                    )}
                                    onChange={(value) => {
                                      handleOnChange(value, qg, item);
                                    }}
                                    showSearch={false}
                                  />
                                </FormItem>
                              )}

                              {item?.interfaceTypeID === 50000002 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <TextField
                                    onChange={(e) =>
                                      handleKeyDownChange(e, qg, item)
                                    }
                                  />
                                </FormItem>
                              )}

                              {item?.interfaceTypeID === 50000003 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <TextField
                                    inputType="textarea"
                                    onChange={(e) =>
                                      handleKeyDownChange(e, qg, item)
                                    }
                                  />
                                </FormItem>
                              )}

                              {item?.interfaceTypeID === 50000004 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <Select
                                    id={`question-${quesIndex}`}
                                    placeholder=" Select any option"
                                    options={getOptionsFromRefList(
                                      item?.refListName,
                                      false,
                                      false,
                                      true,
                                      item?.selectRefListID
                                    )}
                                    onChange={(value) => {
                                      handleOnChange(value, qg, item);
                                    }}
                                    showSearch={false}
                                  />
                                </FormItem>
                              )}

                              {item?.interfaceTypeID === 50000005 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <CommonDatePicker
                                    id={`question-${quesIndex}`}
                                    placeholder="MM/DD/YYYY"
                                    format="MM/DD/YYYY"
                                    showTime={false}
                                    onChange={(value) => {
                                      if (isNonEmptyVariable(value)) {
                                        handleOnChange(value, qg, item);
                                      }
                                    }}
                                  />
                                </FormItem>
                              )}
                            </div>
                            <div className="point-container">
                              <div className="points">
                                {item?.point || 0}
                                <div className="pts">pts</div>
                              </div>
                              <div className="icon-container"></div>
                            </div>
                          </div>
                        )}

                        {typeof item?.dependsOnQuestionID !== "undefined" && (
                          <div
                            style={
                              getDependenciesQuestion(values, item) &&
                              item?.showOnlyIf
                                ? { display: "flex" }
                                : { display: "none" }
                            }
                            className="question-item"
                          >
                            <div className="question">
                              <span className="number">{sequence}.</span>{" "}
                              <span className="question--text-label">
                                {item?.questionText}
                              </span>
                            </div>
                            <div className="options-container">
                              {item?.interfaceTypeID === 50000001 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <Select
                                    id={`question-${quesIndex}`}
                                    placeholder=" Select any option"
                                    options={getOptionsFromRefList(
                                      "YesNo",
                                      false,
                                      true,
                                      true
                                    )}
                                    onChange={(value) => {
                                      handleOnChange(value, qg, item);
                                    }}
                                    showSearch={false}
                                  />
                                </FormItem>
                              )}

                              {item?.interfaceTypeID === 50000002 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <TextField
                                    onChange={(e) =>
                                      handleKeyDownChange(e, qg, item)
                                    }
                                  />
                                </FormItem>
                              )}

                              {item?.interfaceTypeID === 50000003 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <TextField
                                    inputType="textarea"
                                    onChange={(e) =>
                                      handleKeyDownChange(e, qg, item)
                                    }
                                  />
                                </FormItem>
                              )}

                              {item?.interfaceTypeID === 50000004 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <Select
                                    id={`question-${quesIndex}`}
                                    placeholder=" Select any option"
                                    options={getOptionsFromRefList(
                                      item?.refListName,
                                      false,
                                      false,
                                      true,
                                      item?.selectRefListID
                                    )}
                                    onChange={(value) => {
                                      handleOnChange(value, qg, item);
                                    }}
                                    showSearch={false}
                                  />
                                </FormItem>
                              )}

                              {item?.interfaceTypeID === 50000005 && (
                                <FormItem
                                  name={getQuestionPositinFromQuestionID(item)}
                                  rules={getValidation(item)}
                                >
                                  <CommonDatePicker
                                    id={`question-${quesIndex}`}
                                    placeholder="MM/DD/YYYY"
                                    format="MM/DD/YYYY"
                                    showTime={false}
                                    onChange={(value) => {
                                      if (isNonEmptyVariable(value)) {
                                        handleOnChange(value, qg, item);
                                      }
                                    }}
                                  />
                                </FormItem>
                              )}
                            </div>
                            <div className="point-container">
                              <div className="points">
                                {item?.point || 0}
                                <div className="pts">pts</div>
                              </div>
                              <div className="icon-container"></div>
                            </div>
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </QuestionnaireModalBodyContainer>
            );
          })}
      </Form>
    </Modal>
  );
};

export default MedicalQuestionnaireModal;
